import './ClassicEventView.scss';
import { useTranslation } from 'react-i18next';
import ClassicReleaseEventDetail from './ClassicReleaseEventDetail';
import { eventActivityType, eventTrainingList } from '../../constants/myBlockMonth';
import { getDateInWeekDayMonthDateFormat } from '../../helpers/dateHelpers';
import { formatNumToTime } from '../../helpers/timeHelpers';
import { getEventBaseLocation, getEventTimezone } from '../../pages/MyBlockMonth/myBlockMonthHelper';
import { useProfile } from '../../providers/Profile';

function ClassicSpecialEventView({activityType, event}) {
    const { t } = useTranslation();
    const profileContext = useProfile();
    
    return (
        <>
            <div className='classicEventView_specialEvent_container'>
                {activityType === eventActivityType.DSP || activityType === eventActivityType.ITC || activityType === eventActivityType.SDO || 
                activityType === eventActivityType.SICK || activityType === eventActivityType.SICK_INS || activityType === eventActivityType.TRAINING || 
                activityType === eventActivityType.VACATION || activityType === eventActivityType.VAC2448 ? (
                    <div className='classicEventView_specialEvent_details'>
                        <p className='classicEventView_specialEvent_header'>
                            {
                                (activityType === eventActivityType.DSP || activityType === eventActivityType.TRAINING || activityType === eventActivityType.SDO || activityType === eventActivityType.ITC) ? t('myBlockMonth.displacedDays') 
                                : activityType === eventActivityType.SICK ? t('myBlockMonth.sickDay')
                                : activityType === eventActivityType.SICK_INS ? t('myBlockMonth.gdipDay')
                                : activityType === eventActivityType.VACATION ? t('myBlockMonth.vacationDay')
                                : t('myBlockMonth.days')
                            }
                        </p>
                        <p className='classicEventView_specialEvent_values'>{event.days}</p>
                    </div>
                ) : null}
                
                {activityType === eventActivityType.GDO || activityType === eventActivityType.GDO6 || activityType === eventActivityType.RAP || 
                activityType === eventActivityType.RAPH || activityType === eventActivityType.RESERVE || activityType === eventActivityType.TDO || 
                activityType === eventActivityType.TDO6 ? (
                    <div className='classicEventView_specialEvent_details' style={{width:activityType === eventActivityType.RAP ? '12.1rem' : ''}}>
                        <p className='classicEventView_specialEvent_header'>{t('myBlockMonth.duration')}:</p>
                        <p className='classicEventView_specialEvent_values'>{event.duration}</p>
                    </div> 
                ): null}

                {activityType === eventActivityType.DSP || activityType === eventActivityType.REASSIGN  ? (
                    <div className='classicEventView_specialEvent_details'>
                        <p className={activityType === eventActivityType.REASSIGN ? 'classicEventView_specialEvent_header' : 'classicEventView_specialEvent_headervalue'}>{activityType === eventActivityType.DSP || activityType === eventActivityType.REASSIGN ? t('myBlockMonth.protectedCredit') : t('myBlockMonth.credit')}:</p>
                        <p className='classicEventView_specialEvent_values'>{(activityType === eventActivityType.DSP || activityType === eventActivityType.REASSIGN) ? event?.originalPairingCredit : (event?.credit?.value && formatNumToTime(event?.credit?.value)) || "N/A"}</p>
                    </div>
                ): null}
                <>
                    <div className='classicEventView_specialEvent_details' style={{width: activityType === eventActivityType.RAP  ? '29.4rem' : ''}}>
                        <p className='classicEventView_specialEvent_headervalue'>{t('myBlockMonth.start')}:</p>
                        <p className='classicEventView_specialEvent_datevalue'>{getDateInWeekDayMonthDateFormat(new Date(event?.start_date + ' 00:00'))}</p>
                        <p className='classicEventView_specialEvent_timevalue'>{formatNumToTime(event?.checkIn?.value)} {getEventTimezone(event?.timezone)}</p>
                    </div>
                    <div className='classicEventView_specialEvent_details'  style={{width: activityType === eventActivityType.RAP  ? '25rem' : ''}}>
                        <p className='classicEventView_specialEvent_header'>{t('myBlockMonth.end')}:</p>
                        <p className='classicEventView_specialEvent_datevalue'>{getDateInWeekDayMonthDateFormat(new Date(event?.end_date + ' 00:00'))}</p>
                        <p className='classicEventView_specialEvent_timevalue'>{formatNumToTime(event?.checkOut?.value)} {getEventTimezone(event?.timezone)}</p>
                    </div>
                </>
                {event.activityId === eventTrainingList.SIM || event.activityId === eventTrainingList.SIMTRAVEL ? (
                    <div className='classicEventView_specialEvent_details'>
                        <p className='classicEventView_specialEvent_header'>{t('myBlockMonth.location')}:</p>
                        <p className='classicEventView_specialEvent_values'>{getEventBaseLocation(event,profileContext)}</p>
                    </div>
                ) : null}
                {activityType === eventActivityType.RAP || activityType === eventActivityType.RAPH ? (
                    <div className='classicEventView_specialEvent_details'>
                        <p className='classicEventView_specialEvent_header'>{t('myBlockMonth.rapPilotPosition')}:</p>
                        <p className='classicEventView_specialEvent_values'>{event.RAPPilotPosition}</p>
                    </div>
                ) : null}
            </div>
            {activityType === eventActivityType.DSP || activityType === eventActivityType.RAPH || activityType === eventActivityType.SICK_INS ? (
                <div className="classicEventView_dispalcedEvent_remarks">
                    <span className='classicEventView_dispalcedEvent_remarks_header'>{t('myBlockMonth.remarks')}
                        {
                            activityType === eventActivityType.RAPH ? (
                                <span className='classicEventView_dispalcedEvent_remarks_values'>{t('myBlockMonth.remarksRAPH')}</span>
                            ) : activityType === eventActivityType.SICK_INS ? (
                                <span className='classicEventView_dispalcedEvent_remarks_values'>{t('myBlockMonth.remarksGDIP')}</span>
                            ) : activityType === eventActivityType.DSP ? (
                                <span className='classicEventView_dispalcedEvent_remarks_values'>{t('myBlockMonth.remarksDISP')}</span>
                            ) : null
                        }
                    </span>
                </div>
            ) : null}
            
            {/* RAP with Release */}
            {activityType === eventActivityType.RAP && event?.release ? (
              event?.release.map(event => <ClassicReleaseEventDetail activityType={activityType} event={event} />)  
            ) : null}
        </>
    );
}

export default ClassicSpecialEventView;